import { Contest, DesignDetails, GalleryDesign, User, UsersILike } from '../global';
import { ROUTEPATHS } from '../routes/routePaths';

export function userUrlForUser(user: User | UsersILike | string, isClient?: boolean): string {
  if (typeof user === 'string') {
    if (isClient) {
      return `/${ROUTEPATHS.CLIENT}/${user}/${ROUTEPATHS.COMMUNITY_PROFILE}`;
    } else {
      return `/${ROUTEPATHS.USER}/${user}/${ROUTEPATHS.COMMUNITY_PROFILE}`;
    }
  }
  if (user.userType === 'D') {
    return `/${ROUTEPATHS.USER}/${user.nameForURL}/${ROUTEPATHS.COMMUNITY_PROFILE}`;
  } else {
    return `/${ROUTEPATHS.CLIENT}/${user.nameForURL}/${ROUTEPATHS.COMMUNITY_PROFILE}`;
  }
}
export function profilePreviewUrlForUser(user: User): string {
  if (user.userType === 'D') {
    return `/${ROUTEPATHS.USER}/${user.nameForURL}/${ROUTEPATHS.COMMUNITY_PROFILE_PREVIEW}`;
  } else {
    return `/${ROUTEPATHS.CLIENT}/${user.nameForURL}/${ROUTEPATHS.COMMUNITY_PROFILE_PREVIEW}`;
  }
}

export function portfolioUrlForUser(user: User | UsersILike | string): string {
  if (typeof user === 'string') {
    return `/${ROUTEPATHS.USER}/${user}/${ROUTEPATHS.COMMUNITY_PORTFOLIO}`;
  }
  if (user.userType === 'D') {
    return `/${ROUTEPATHS.USER}/${user.nameForURL}/${ROUTEPATHS.COMMUNITY_PORTFOLIO}`;
  } else {
    return `/${ROUTEPATHS.CLIENT}/${user.nameForURL}/${ROUTEPATHS.COMMUNITY_PORTFOLIO}`;
  }
}

export function briefUrlForContest(contest: Contest | string): string {
  if (typeof contest === 'string') {
    return `/${ROUTEPATHS.CONTEST}/${contest}/${ROUTEPATHS.CONTEST_BRIEF}`;
  }
  return `/${ROUTEPATHS.CONTEST}/${contest.nameForURL}/${ROUTEPATHS.CONTEST_BRIEF}`;
}
export function uploadUrlForContest(contest: Contest): string {
  return `/${ROUTEPATHS.CONTEST}/${contest.nameForURL}/${ROUTEPATHS.CONTEST_UPLOAD}`;
}
export function awardsUrlForContest(contest: Contest|string): string {
  if (typeof contest === 'string') {
    return `/${ROUTEPATHS.CONTEST}/${contest}/${ROUTEPATHS.CONTEST_AWARDS}`;
  }
  return `/${ROUTEPATHS.CONTEST}/${contest.nameForURL}/${ROUTEPATHS.CONTEST_AWARDS}`;
}
export function galleryUrlForContest(contest: Contest): string {
  return `/${ROUTEPATHS.CONTEST}/${contest.nameForURL}/${ROUTEPATHS.CONTEST_GALLERY}`;
}
export function designUrlForContestName(contestNameForUrl: string, design: GalleryDesign | DesignDetails | string): string {
  if (typeof design === 'string') {
    return `/${ROUTEPATHS.CONTEST}/${contestNameForUrl}/${ROUTEPATHS.CONTEST_GALLERY}/${design}`;
  }
  return `/${ROUTEPATHS.CONTEST}/${contestNameForUrl}/${ROUTEPATHS.CONTEST_GALLERY}/${design.nameForURL}`;
}
export function designUrlForGallery(user: User, design: GalleryDesign): string {
  return `/${ROUTEPATHS.USER}/${user.nameForURL}/${ROUTEPATHS.COMMUNITY_PORTFOLIO}/${design.nameForURL}`;
}
export function designUrlForGalleryFromNames(userNameForURL: string, designNameForURL: string): string {
  return `/${ROUTEPATHS.USER}/${userNameForURL}/${ROUTEPATHS.COMMUNITY_PORTFOLIO}/${designNameForURL}`;
}
